import { Button, PreIcon } from '@advanza/ui'
import A from 'components/ui/A'
import { Provider } from 'interfaces/Providers'
import { getCompanyBaseUrlOffice } from 'misc/companyBaseUrlOffice'

interface Props {
    provider: Provider
}

const ProfileUrlLink = ({ provider }: Props) => {
    const baseUrl = getCompanyBaseUrlOffice(provider.country_code)

    const getError = (): string | false => {
        if (!provider.profile_url) {
            return 'Profile url field is empty'
        }
        if (!provider.providerUrl) {
            return 'No active filters'
        }
        if (!provider.providerUrlVisible) {
            return 'Service is not live yet'
        }
        return false
    }
    const error = getError()

    return error ? (
        <PreIcon icon="warning" red fontSize={16}>
            <span style={{ color: '#f42435' }}>{error}</span>
        </PreIcon>
    ) : (
        <A external href={`${baseUrl}${provider.providerUrl}`} target="_blank">
            <Button name="textReadMore">To profile</Button>
        </A>
    )
}

export default ProfileUrlLink
